import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import MUIDataTable from "mui-datatables";
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import toast from 'react-hot-toast';

class TokenFeedbacks extends Component {
    constructor(props) {
        super(props);

        this.state = {
            baseUrl: localStorage.getItem("API_URL"),
            token: localStorage.getItem("user_token"),

            // Dashboard Summary
            summary: {
                issuedTokens: 0,
                givenFeedbacks: 0,
                notGiven: 0,
                avgRating: 0,
                maxScore: 5
            },

            // Bar Chart
            barChartOptions: {
                chart: { id: "category-ratings", toolbar: { show: false } },
                xaxis: { categories: [] },
                title: { 
                    text: "Category Wise Ratings", 
                    align: 'left',
                    style: { color: '#ffffff' }
                },
                colors: ['#007bff']
            },
            barChartSeries: [
                { name: "Avg Rating", data: [] }
            ],

            // Donut Chart
            donutChartOptions: {
                labels: [],
                title: { 
                    text: "Feedback Percentages", 
                    align: 'left',
                    style: { color: '#ffffff' }
                },
                colors: ['#28a745', '#a8f29aff', '#e6d08cff', '#ffc107', '#f59607ff', '#ff605bff', '#ff5207ff', '#fd1414ff', '#c1a8a7ff', '#686868ff', '#2f2f2fff', '#000000ff'],
                tooltip: {
                    y: {
                        formatter: (value) => {
                            const series = this.state.donutChartSeries;
                            const total = series.reduce((a, b) => Number(a) + Number(b), 0);
                            const percent = total === 0 ? 0 : ((Number(value) / total) * 100).toFixed(1);
                            return `${percent}%`;
                        }
                    }
                }
            },
            donutChartSeries: [],

            showModal: false,
            modalData: [],
            isModalLoading: false,
            selectedTicketNo: "",
            selectedTicketRating: 0,

            // Table Data
            page: 0,
            size: 5,
            searchText: "",
            totalRows: 0,
            tableData: [],

            tableColumns: [
                { name: "branch", label: "Branch" },
                { name: "issuedDate", label: "Date" },
                { name: "ticketNo", label: "Ticket No" },
                { name: "category", label: "Category" },
                { name: "counterName", label: "Counter" },
                { name: "startTime", label: "Start Date" },
                { name: "endTime", label: "End Date" },
                { name: "servedTellerName", label: "Teller Name" },
                {
                    name: "rating",
                    label: "Ratings",
                    options: {
                        customBodyRender: (value) => {
                            const rating = Number(value) || 0;
                            const fullStars = Math.floor(rating);
                            const hasHalfStar = rating % 1 >= 0.5;

                            return (
                                <div style={{ minWidth: '100px', color: '#ffc107' }}>
                                    {[...Array(fullStars)].map((_, i) => <i key={`full-${i}`} className="fa fa-star" />)}
                                    {hasHalfStar && <i className="fa fa-star-half-o" />}
                                    <span className="text-dark" style={{ fontSize: '0.85em', marginLeft: '5px' }}>({rating.toFixed(1)})</span>
                                </div>
                            );
                        }
                    }
                },
                {
                    name: "Feedback",
                    options: {
                        filter: false,
                        sort: false,
                        customBodyRender: (value, tableMeta, updateValue) => {
                            return (
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => this.handleOpenModal(tableMeta.rowIndex)}
                                >
                                    View
                                </button>
                            );
                        }
                    }
                }
            ],
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        const { baseUrl, token, page, size, searchText } = this.state;

        let userDetails = JSON.parse(localStorage.getItem("user_details"));
        let customerId = userDetails ? userDetails['cid'] : null;

        const requestPayload = {
            page: page,
            size: size,
            id: customerId,
            sort: null,
            searchText: searchText || ""
        };

        axios({
            method: 'POST',
            url: `${baseUrl}/feedback/queue-integrated-dashboard`,
            headers: {
                Authorization: token
            },
            data: requestPayload
        })
            .then(res => {
                if (res.data && res.data.data) {
                    const data = res.data.data;

                    const summary = data.feedbackSummary || {};

                    const barData = data.feedbackCategorySummaryBarChart || [];
                    const barCategories = barData.map(item => item.category);
                    const barSeriesData = barData.map(item => item.avgRating);

                    const donutData = data.feedbackCountDonutChart || [];
                    const donutLabels = donutData.map(item => item.feedback);
                    const donutSeries = donutData.map(item => item.givenFeedbacks);

                    const pageData = data.tableData || { content: [], totalElements: 0 };

                    this.setState({
                        summary: {
                            issuedTokens: summary.issuedTokens || 0,
                            givenFeedbacks: summary.givenFeedbacks || 0,
                            avgRating: summary.avgRating || 0,
                            notGiven: summary.notGiven || 0,
                            maxScore: summary.maxScore || 5
                        },
                        barChartOptions: {
                            ...this.state.barChartOptions,
                            xaxis: { categories: barCategories },
                            yaxis: data.barCartMax ? {
                                max: data.barCartMax,
                                tickAmount: data.barCartMax <= 10 ? data.barCartMax : undefined,
                                labels: { formatter: (val) => Math.floor(val) }
                            } : {}
                        },
                        barChartSeries: [{ name: "Avg Rating", data: barSeriesData }],
                        donutChartOptions: { ...this.state.donutChartOptions, labels: donutLabels },
                        donutChartSeries: donutSeries,
                        tableData: pageData.content,
                        totalRows: pageData.totalElements
                    });
                }
            })
            .catch(err => {
                console.error("Error fetching dashboard data:", err);
                toast.error("Failed to load dashboard data", { position: "bottom-center" });
            });
    }

    handleTableChange = (action, tableState) => {
        switch (action) {
            case 'changePage':
                this.setState({ page: tableState.page }, () => this.fetchData());
                break;
            case 'changeRowsPerPage':
                this.setState({ size: tableState.rowsPerPage, page: 0 }, () => this.fetchData());
                break;
            case 'search':
                this.setState({ searchText: tableState.searchText, page: 0 }, () => this.fetchData());
                break;
            default:
                break;
        }
    }

    handleOpenModal = (rowIndex) => {
        const ticket = this.state.tableData[rowIndex];
        const ticketId = ticket ? ticket.id : null;
        const ticketNo = ticket ? ticket.ticketNo : "";
        const rating = ticket ? ticket.rating : 0;

        this.setState({ showModal: true, modalData: [], isModalLoading: true, selectedTicketNo: ticketNo, selectedTicketRating: rating });

        if (!ticketId) {
            this.setState({ isModalLoading: false });
            return;
        }

        const { baseUrl, token } = this.state;

        axios({
            method: 'GET',
            url: `${baseUrl}/feedback/Q&A/ticket/${ticketId}`,
            headers: {
                Authorization: token
            }
        })
            .then(res => {
                if (res.data && res.data.data) {
                    this.setState({ modalData: res.data.data, isModalLoading: false });
                } else {
                    this.setState({ isModalLoading: false });
                }
            })
            .catch(err => {
                console.error("Error fetching feedback details:", err);
                toast.error("Failed to load feedback details", { position: "bottom-center" });
                this.setState({ isModalLoading: false });
            });
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    render() {
        const { summary, tableData, totalRows, page, size, modalData, isModalLoading, selectedTicketNo, selectedTicketRating } = this.state;

        // Stars calculation for the selected ticket in the Modal
        const modalRatingValue = Number(selectedTicketRating) || 0;
        const modalFullStars = Math.floor(modalRatingValue);
        const modalHasHalfStar = modalRatingValue % 1 >= 0.5;

        // Stars calculation for Avg Rating
        const avgRatingValue = Number(summary.avgRating) || 0;
        const avgFullStars = Math.floor(avgRatingValue);
        const avgHasHalfStar = avgRatingValue % 1 >= 0.5;

        const tableOptions = {
            filterType: 'checkbox',
            selectableRows: 'none',
            responsive: 'standard',
            serverSide: true,
            count: totalRows,
            page: page,
            rowsPerPage: size,
            rowsPerPageOptions: [5, 10, 20],
            search: true,
            print: false,
            download: false,
            onTableChange: this.handleTableChange
        };

        return (
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-5 col-md-8 col-sm-12">
                            <h2>Token Feedbacks</h2>
                        </div>
                    </div>
                </div>

                <div className="row clearfix">
                    {/* 3 Cards */}
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="card text-center">
                            <div className="body">
                                <h6>Total Feedbacks</h6>
                                <h3>{summary.givenFeedbacks}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="card text-center">
                            <div className="body">
                                <h6>Issued Tokens</h6>
                                <h3>{summary.issuedTokens}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="card text-center">
                            <div className="body">
                                <h6>Skipped</h6>
                                <h3>{summary.notGiven}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="card text-center">
                            <div className="body">
                                <h6>Avg. Rating ({summary.avgRating} / {summary.maxScore})</h6>
                                <h3>
                                    <span style={{ color: '#ffc107', fontSize: '0.9em', marginRight: '10px' }}>
                                        {[...Array(avgFullStars)].map((_, i) => <i key={`full-${i}`} className="fa fa-star" />)}
                                        {avgHasHalfStar && <i className="fa fa-star-half-o" />}
                                    </span>
                                    {/* {summary.avgRating} / {summary.maxScore} */}
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row clearfix">
                    {/* Bar Chart */}
                    <div className="col-lg-8 col-md-12 col-sm-12">
                        <div className="card">
                            <div className="body">
                                <Chart
                                    options={this.state.barChartOptions}
                                    series={this.state.barChartSeries}
                                    type="bar"
                                    height="350"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Donut Chart */}
                    <div className="col-lg-4 col-md-12 col-sm-12">
                        <div className="card">
                            <div className="body">
                                <Chart
                                    options={this.state.donutChartOptions}
                                    series={this.state.donutChartSeries}
                                    type="donut"
                                    height="350"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row clearfix">
                    {/* Data Table */}
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card">
                            <div className="body">
                                <MUIDataTable
                                    title={"Feedback List"}
                                    data={tableData}
                                    columns={this.state.tableColumns}
                                    options={tableOptions}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Feedback Modal */}
                <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Feedback Details {selectedTicketNo ? `- ${selectedTicketNo}` : ""}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-3">
                            <strong>Overall Rating: </strong>
                            <span style={{ color: '#ffc107', fontSize: '1.2em', marginLeft: '5px' }}>
                                {[...Array(modalFullStars)].map((_, i) => <i key={`full-${i}`} className="fa fa-star" />)}
                                {modalHasHalfStar && <i className="fa fa-star-half-o" />}
                            </span>
                            {/* <span className="text-dark font-weight-bold" style={{ marginLeft: '10px' }}>({modalRatingValue.toFixed(1)})</span> */}
                        </div>
                        <hr />
                        {isModalLoading ? (
                            <p>Loading details...</p>
                        ) : modalData && modalData.length > 0 ? (
                            modalData.map((qa, index) => (
                                <div key={index}>
                                    <h6><strong>Q: {qa.question}</strong></h6>
                                    <p>A: {qa.answer}</p>
                                    {index < modalData.length - 1 && <hr />}
                                </div>
                            ))
                        ) : (
                            <p>No feedback details available.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default TokenFeedbacks;
